import { z } from 'zod';
import { emailSchema, roleSchema } from './common';
import { tenantStatusSchema } from './tenants';

export const loginRequestSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Password is required').max(256),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const userDtoSchema = z.object({
  id: z.uuid(),
  email: z.string(),
  name: z.string(),
  isSuperAdmin: z.boolean(),
});
export type UserDto = z.infer<typeof userDtoSchema>;

export const membershipDtoSchema = z.object({
  tenantId: z.uuid(),
  tenantName: z.string(),
  tenantSlug: z.string(),
  tenantStatus: tenantStatusSchema,
  role: roleSchema,
});
export type MembershipDto = z.infer<typeof membershipDtoSchema>;

export const activeTenantDtoSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  status: tenantStatusSchema,
  role: roleSchema,
});
export type ActiveTenantDto = z.infer<typeof activeTenantDtoSchema>;

export const meResponseSchema = z.object({
  user: userDtoSchema,
  activeTenant: activeTenantDtoSchema.nullable(),
  memberships: z.array(membershipDtoSchema),
  csrfToken: z.string(),
});
export type MeResponse = z.infer<typeof meResponseSchema>;

export const switchTenantRequestSchema = z.object({ tenantId: z.uuid() });

export const authProvidersResponseSchema = z.object({ google: z.boolean() });
export type AuthProvidersResponse = z.infer<typeof authProvidersResponseSchema>;
